<!-- <p>modal-reserva-confirmada works!</p> -->

<div id="reservaok" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="loginLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="margin: auto;">
      <div class="modal-content">
        <div class="modal-header d-block border-0 text-center">
          <img src="assets/images/body/reserva-ok.svg" class="mt-5" alt="">
          <h3 class="modal-title text-secondary text-center m-auto" id="loginLabel">Viaje reservado</h3>
          <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
          <i (click)="closeModal()" class="bi-x modal-close" aria-label="Close"></i>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-2"></div>
            <div class="col-lg-8" *ngIf="data">
              <p class="mb-1 text-center mb-4">N° de Reserva: {{data.codigo}}</p>
              <h6 class="text-secondary text-center">Ficha de Viaje</h6>
              <p class="text-secondary text-center mt-3">
                <a style="cursor: pointer;"  (click)=" descargarPlanilla()" class="btn btn-lg btn-outline-primary rounded-pill border border-2  border-primary"  ><img src="assets/images/body/descargar-icono.svg" class="pe-4" alt="" width="50"> Descargar</a>
              </p>
              <p class="text-secondary text-center mt-3">
                <a style="cursor: pointer;"  (click)=" goHome()" class="btn btn-lg btn-primary btn-reservar rounded-pill" >Volver al Home</a>
              </p>
            </div>
            <div class="col-lg-2"></div>
          </div>
        </div>
        <div class="modal-footer border-0">
          <img src="assets/images/body/reserva-ok-personas.svg" class="d-none d-lg-block" style="max-height: inherit;">
        
        </div>
      </div>
    </div>
  </div>